import { css } from '@eti/styles';
export const rowIconWrapperStyles = css`
  padding: 8px;
  position: relative;
  text-align: center;
  width: 36px;

  @media (min-width: 48em) {
    padding: 12px;
    width: 44px;
  }
`;
export const dataCellStyles = css`
  font-size: 0.625rem;
  min-height: 0.625rem;

  html[dir='rtl'] & {
    text-align: right;
  }

  @media (min-width: 48em) {
    font-size: 0.75rem;
  }

  @media (min-width: 60.625em) {
    font-size: 0.875rem;
  }
`;
export const resetButtonStyles = css`
  appearance: none;
  border: 0;
  font-family: inherit;
  padding: 0;
  text-align: left;

  html[dir='rtl'] & {
    text-align: right;
  }
`;
//# sourceMappingURL=styles.js.map